function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import "core-js/modules/web.dom.iterable.js";
import { useContext, useEffect, useState } from 'react';
import ExperienceContext from '../components/ExperienceContext';
const parse = input => {
  let val = input;
  if (val === 'true') val = true;
  if (val === 'false') val = false;
  if (/^\d+$/.test(val)) val = parseInt(val, 10);
  if (/^\d+\.\d+$/.test(val)) val = parseFloat(val);
  return val;
};
export const useConfigService = key => {
  const {
    configService: csContext = {}
  } = useContext(ExperienceContext);
  const [configService, setConfigService] = useState(csContext);
  const lifeCycleCB = _ref => {
    let {
      output
    } = _ref;
    setConfigService(existing => _objectSpread(_objectSpread({}, existing), output));
  };
  useEffect(() => {
    window.LIFE_CYCLE_EVENT_BUS.lifeCycle.on('CONFIG_SERVICE_CHANGE', lifeCycleCB);
    window.LIFE_CYCLE_EVENT_BUS.on('CONFIG_SERVICE_CHANGE', lifeCycleCB);
    return () => {
      window.LIFE_CYCLE_EVENT_BUS.lifeCycle.off('CONFIG_SERVICE_CHANGE', lifeCycleCB);
      window.LIFE_CYCLE_EVENT_BUS.off('CONFIG_SERVICE_CHANGE', lifeCycleCB);
    };
  }, []);
  if (key) {
    return parse(configService[key]);
  }
  const ret = Object.keys(configService).reduce((acc, cur) => {
    return _objectSpread(_objectSpread({}, acc), {}, {
      [cur]: parse(configService[cur])
    });
  }, {});
  return ret;
};
//# sourceMappingURL=useConfigService.js.map